var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.navigationLink)?_c('navigation-link-form',{key:_vm.navigationLink.id,attrs:{"navigation-links":_vm.navigationLinks,"navigation-link":_vm.navigationLink,"is-editing":true},on:{"onSubmit":_vm.handleSubmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }